import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent, AuthenticationLayoutComponent } from './core';
import { AuthGuard } from './shared';

export const AppRoutes: Routes = [
    {
        path: '',
        component: AdminLayoutComponent,
        children: [{
            path: '',
            loadChildren: './pages/pages.module#PagesModule',
            canActivate: [AuthGuard]
        }]
    },
    {
        path: '',
        component: AuthenticationLayoutComponent,
        children: [{
            path: '',
            loadChildren: './authentication/authentication.module#AuthenticationModule'
        }]
    }

]
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(AppRoutes, { onSameUrlNavigation: 'reload', useHash: true })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }